import type { AiSuggestionStore } from './AiSuggestionStore';
import type { CommentStore } from './CommentStore';
import type { FeedbackStore } from './FeedbackStore';
import type { LabelStore } from './LabelStore';
import type { OpenBranchesStore } from './OpenBranchesStore';
import { createStoreSlot } from './lazyStoreSlot';

/**
 * T-0892 (T-0770): the slots of the stores no first screen draws. Each is built by its `*StoreInstance.ts`
 * module, which the screens that use it import; only types are imported here, so this file carries none of them.
 */
export const commentStoreSlot = createStoreSlot<CommentStore>('comment store', () =>
  import('./commentStoreInstance').then((module) => module.commentStore),
);
export const aiSuggestionStoreSlot = createStoreSlot<AiSuggestionStore>('AI suggestion store', () =>
  import('./aiSuggestionStoreInstance').then((module) => module.aiSuggestionStore),
);
export const feedbackStoreSlot = createStoreSlot<FeedbackStore>('feedback store', () =>
  import('./feedbackStoreInstance').then((module) => module.feedbackStore),
);
export const labelStoreSlot = createStoreSlot<LabelStore>('label store', () =>
  import('./labelStoreInstance').then((module) => module.labelStore),
);
export const openBranchesStoreSlot = createStoreSlot<OpenBranchesStore>('open branches store', () =>
  import('./openBranchesStoreInstance').then((module) => module.openBranchesStore),
);
